import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";

export const LegalModal = ({ open, onOpenChange, content }) => {
  if (!content) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-2xl max-h-[80vh] overflow-y-auto"
        data-testid="legal-modal"
      >
        <DialogHeader>
          <DialogTitle className="font-display font-extrabold text-2xl text-[#0b1221]">
            {content.title}
          </DialogTitle>
          <DialogDescription className="text-[#5e6c84]">
            {content.updated}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-2">
          {content.body.map((p, i) => (
            <p key={i} className="text-[#5e6c84] leading-relaxed text-sm">
              {p}
            </p>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
